import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Box, Button, Menu } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import StyledButtonV2 from "@/components/app/StyledButtonV2";
import SignAndLockDrawer from "./default-forms/SignAndLockDrawer";
import useDisclosure from "@/hooks/use-disclosure";
import { useSnackbar } from "@/hooks/useSnackbar";

interface SaveAndSignButtonProps {
  label: string;
  prefillSummeryData?: any;
  onSave?: () => void;
  navigateWithoutGuard?: (callback: () => void) => void;
  signValidationMessage?: string;
}

const EncounterSign = ({
  label,
  prefillSummeryData,
  onSave,
  navigateWithoutGuard,
  signValidationMessage,
}: SaveAndSignButtonProps) => {
  return (
    <PopupState variant="popover" popupId="create-navbar-button-menu">
      {(menuList) => (
        <>
          <Box {...bindTrigger(menuList)}>
            <StyledButtonV2
              variant="contained"
              size="small"
              label={label}
              onClick={onSave}
            />
          </Box>

          <Menu
            {...bindMenu(menuList)}
            sx={{
              "& .MuiMenu-list": {
                paddingTop: 0,
              },
            }}
          >
            <SignMiniPopUp
              onClose={menuList.close}
              prefillSummeryData={prefillSummeryData}
              navigateWithoutGuard={navigateWithoutGuard}
              signValidationMessage={signValidationMessage}
            />
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default EncounterSign;

interface SignMiniPopUpProps {
  onClose: () => void;
  prefillSummeryData?: any;
  navigateWithoutGuard?: (callback: () => void) => void;
  signValidationMessage?: string;
}

const SignMiniPopUp = ({
  onClose,
  prefillSummeryData,
  navigateWithoutGuard,
  signValidationMessage,
}: SignMiniPopUpProps) => {
  const signDrawerDisclosure = useDisclosure(false, { onClose: onClose });
  const showSnackbar = useSnackbar();

  const handleSign = () => {
    if (signValidationMessage) {
      showSnackbar({ message: signValidationMessage, type: "error" });
      onClose();
      return;
    }
    signDrawerDisclosure.open();
  };

  return (
    <Flex
      sx={{
        width: "369px",
        height: "168px",
      }}
      flexDirection={"column"}
      justifyContent={"space-between"}
    >
      <SignAndLockDrawer
        disclosureHost={signDrawerDisclosure}
        prefillSummeryData={prefillSummeryData}
        navigateWithoutGuard={navigateWithoutGuard}
      />
      <Flex
        justifyContent={"space-between"}
        width={"100%"}
        height={"30px"}
        alignItems={"center"}
        px={1.6}
        bgcolor={"#FF800226"}
      >
        <Flex gap={0.4} alignItems={"center"}>
          <ErrorOutlineIcon color="error" />
          <Text>Sign Visit</Text>
        </Flex>

        <CloseIcon
          fontSize="small"
          sx={{
            cursor: "pointer",
          }}
          onClick={() => onClose()}
        />
      </Flex>
      <Text px={1.6}>
        This will permanently finalize this encounter as a legal document. You
        will not be able to make edits after signing.
      </Text>
      <Flex width={"100%"} justifyContent={"end"} px={1.6}>
        <Button variant="contained" sx={{ width: "72px" }} onClick={handleSign}>
          Sign
        </Button>
      </Flex>
    </Flex>
  );
};
